export default "__VITE_ASSET__CSQXTItc__"